import { requests } from "../config";

export const Invites = {
  getInviteDataByToken: (token: string) => requests.get(`/auth/invitation/${token}`, "go"),
  addCompany: (data: {token: string}) => requests.post(`/auth/add_company`, "go", data), 
}